import React from 'react';
import { motion } from 'framer-motion';
import { Star, Award, BadgeCheck } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const miniTestimonials = [{
  quote: 'Sus manos son oro puro.',
  author: 'Angela B.'
}, {
  quote: 'Tan delicada que me quedé dormida.',
  author: 'Mel'
}, {
  quote: 'Excelente servicio, se nota el profesionalismo y experiencia.',
  author: 'Dennisse C.'
}];
export function AboutKate() {
  const {
    t
  } = useLanguage();
  return <section id="kate" className="py-12 md:py-24 bg-brand-white relative overflow-hidden" data-id="element-23" data-mp="ejj1uut2ar1h">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24" data-mp="tg9v0mc576in">
        <div className="text-center mb-10 md:mb-16" data-id="element-25" data-mp="tfrzjrxb0wbs">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-26" data-mp="oh703upvmgoe">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-27" data-mp="2qao66tycz9h1">
              {t('about.title1')}
              <br data-id="element-28" data-mp="1wdpbhw3bu426" />
              <span className="block" data-id="element-29" data-mp="20glwtuk94e9t">{t('about.title2')}</span>
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-30" data-mp="25g6wk778wqnl"></div>
          </motion.div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-31" data-mp="2a6nbxwummmcl">
          {/* Image Column */}
          <motion.div className="w-full lg:w-1/2 flex justify-center" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-32" data-mp="2f6jd7obxvzog">
            <div className="relative group w-full max-w-md" data-id="element-33" data-mp="2t6az0b8p6kd0">
              {/* Decorative background elements */}
              <div className="absolute inset-0 bg-brand-gold/10 transform translate-x-4 translate-y-4 rounded-sm transition-transform duration-700 group-hover:translate-x-6 group-hover:translate-y-6" data-id="element-34" data-mp="ttgom3hf8gfe"></div>
              <div className="absolute inset-0 border border-brand-gold/30 transform -translate-x-4 -translate-y-4 rounded-sm transition-transform duration-700 group-hover:-translate-x-6 group-hover:-translate-y-6" data-id="element-35" data-mp="223p5cfi5i1df"></div>

              {/* Portrait */}
              <div className="relative z-10 overflow-hidden rounded-sm shadow-xl border border-brand-gold/20" data-id="element-36" data-mp="2b0zlae5wyeoo">
                <img src="https://cdn.magicpatterns.com/uploads/jWGUB2RBScED3p116XWAqo/KATE_2.png" alt="Kate - Fundadora de Tairu Aesthetics, en su estudio" className="w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105" data-id="element-37" data-mp="2l19xbvg7pg29" />

                {/* Soft bottom gradient for badge legibility */}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/45 to-transparent" data-id="element-38" data-mp="2ptb4x42fqily"></div>

                {/* Animated gold shine sweep */}
                <motion.div className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 bg-gradient-to-r from-transparent via-white/30 to-transparent" initial={{
                x: '-50%',
                opacity: 0
              }} whileInView={{
                x: '450%',
                opacity: 1
              }} viewport={{
                once: true,
                amount: 0.3
              }} transition={{
                duration: 1.7,
                delay: 0.6,
                ease: 'easeInOut'
              }} data-id="element-39" data-mp="2ytprs7v1s5rk" />

                {/* Google 5-star badge over the image */}
                <motion.div className="absolute bottom-4 left-4 right-4 z-20 bg-white/95 backdrop-blur-sm p-3 md:p-4 rounded-sm shadow-lg border border-brand-gold/20 flex items-center gap-3" initial={{
                opacity: 0,
                y: 16
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.6,
                delay: 0.45
              }} data-id="element-40" data-mp="34fgsq6xmr3mr">
                  <div className="bg-brand-gold/10 p-2 rounded-full flex-shrink-0" data-id="element-41" data-mp="2doazy8ftji9i">
                    <Award className="w-5 h-5 md:w-6 md:h-6 text-brand-gold" data-id="element-42" data-mp="28oyftvgc0pam" />
                  </div>
                  <div data-id="element-43" data-mp="23xosj1i99y1w">
                    <div className="flex text-brand-gold mb-1" data-id="element-44" data-mp="23wwvrncx9ua1">
                      {[...Array(5)].map((_, i) => <motion.span key={i} initial={{
                      opacity: 0,
                      scale: 0.6
                    }} whileInView={{
                      opacity: 1,
                      scale: 1
                    }} viewport={{
                      once: true
                    }} transition={{
                      duration: 0.35,
                      delay: 0.7 + i * 0.09
                    }} data-id="element-45" data-mp="1yzn8ad93fsou" data-mpi={i}>
                          <Star className="w-3.5 h-3.5 fill-current" data-id="element-46" data-mp="1g1u4z9uk5gqx" />
                        </motion.span>)}
                    </div>
                    <p className="text-xs font-bold text-brand-charcoal leading-tight" data-id="element-47" data-mp="3aea8i2vyygs3">
                      {t('about.badge')}
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>

          {/* Copy Column */}
          <motion.div className="w-full lg:w-1/2 space-y-6 text-lg text-brand-charcoal" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-48" data-mp="3rncrwsoyymja">
            <p className="font-serif text-2xl text-brand-gold-light italic" data-id="element-49" data-mp="33x0dr034rtk9">
              {t('about.p1')}
            </p>

            <p data-id="element-50" data-mp="38w3g2crq7loj">{t('about.p2')}</p>

            <div className="flex items-start gap-3 bg-brand-cream p-4 rounded-sm border-l-4 border-brand-gold my-6" data-id="element-51" data-mp="38z7tm0r2ztrv">
              <BadgeCheck className="w-6 h-6 text-brand-gold flex-shrink-0 mt-1" data-id="element-52" data-mp="o6w9juqym4k4" />
              <p className="text-sm" data-id="element-53" data-mp="o909k1lqmjf4">
                {t('about.p3_1')}
                <strong className="text-brand-brown" data-id="element-54" data-mp="t3w53bq6nowz">
                  {t('about.p3_bold')}
                </strong>
                {t('about.p3_2')}
              </p>
            </div>

            <p data-id="element-55" data-mp="3un3an4c1t64e">{t('about.p4')}</p>

            <p className="font-medium text-brand-brown mt-8" data-id="element-56" data-mp="3uq8vu8hk3nuu">{t('about.p5')}</p>

            {/* Mini Testimonials */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8" data-id="element-57" data-mp="8gxyiglxbdrg">
              {miniTestimonials.map((test, idx) => <div key={idx} className="bg-white p-4 border border-brand-gold/10 rounded-sm shadow-sm text-center" data-id="element-58" data-mp="3gvygghrg961g" data-mpi={idx}>
                  <div className="flex justify-center text-brand-gold mb-2" data-id="element-59" data-mp="3byg40he848op">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-60" data-mp="3qn2thbxkegtn" data-mpi={i} />)}
                  </div>
                  <p className="text-sm italic mb-2" data-id="element-61" data-mp="3luswjby18ghv">"{test.quote}"</p>
                  <p className="text-xs font-bold text-brand-brown" data-id="element-62" data-mp="2y5gpahm9mii7">
                    — {test.author}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}